var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCifraNoBgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5513 18.6274C27.5472 26.6674 19.4013 31.5548 11.3728 29.5506C3.33256 27.5464 -1.55486 19.401 0.449398 11.3726C2.45354 3.33256 10.5875 -1.55486 18.6278 0.449399C26.6563 2.44182 31.5556 10.5873 29.5513 18.6274Z",
    fill: "#CED4DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_930_7124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3468 7.28214C9.96908 7.8977 8.83887 11.0956 8.23178 13.3548C7.4967 16.0907 7.496 16.4862 7.68955 17.7349C7.8969 19.075 8.94778 20.5465 10.2182 21.2759C10.9033 21.6693 11.2807 21.7866 15.4919 22.9149L20.0276 24.1303L20.8153 21.1905L17.3006 20.247C13.4784 19.2208 12.9661 19.0209 12.3688 18.3222C11.5721 17.39 11.4301 16.5013 12.1332 13.894C12.3899 12.9416 12.8849 11.3779 13.2331 10.4189C13.5814 9.45993 13.9616 8.35822 13.9885 8.25791C13.6849 8.17657 13.8368 8.21727 12.1677 7.77002C10.4985 7.32277 10.6504 7.36347 10.3468 7.28214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9872 14.4353L15.7517 19.0465L19.3933 20.0223L21.9722 10.3977L18.3306 9.42188L16.9872 14.4353Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_930_7124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1828,
    height: 13.7687,
    fill: "white",
    transform: "translate(9.8916 7.16016) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCifraNoBgDisabled);
export default __webpack_public_path__ + "static/media/cifraNoBgDisabled.2eaa2acc4070cb08f5ca69cce5b64d31.svg";
export { ForwardRef as ReactComponent };